import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 15/10;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 15 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-434.000000, -201.000000)" fill={color}>
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(13.000000, 17.000000)">
                        <path d="M9.03710938,14 L7.50585938,14 L7.50585938,9.63183594 L2.44042969,9.63183594 L2.44042969,14 L0.909179688,14 L0.909179688,4.13574219 L2.44042969,4.13574219 L2.44042969,8.30566406 L7.50585938,8.30566406 L7.50585938,4.13574219 L9.03710938,4.13574219 L9.03710938,14 Z M13.2685547,14 L13.2685547,8.03808594 L13.2441406,8.03808594 L11.4033203,9.34667969 L11.4033203,8.27246094 L13.2587891,6.95410156 L14.3378906,6.95410156 L14.3378906,14 L13.2685547,14 Z" id="H1"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatHeadingOne extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
